import React from 'react';
import Style from './KeyFactsBanner.module.scss';
import { useTranslation } from 'react-i18next';

const KeyFactsBanner = ({ title, image}) => {

  const { t } = useTranslation(["common"]);
  return (
    <section className={Style.hero_wrapper}>
      {image && <img src={image} alt={title} className={Style.hero_img} />}

      <div className={`${Style.hero_container} container`}>
        <h1 className={Style.hero_title}>{t("keyFactsStatement")}</h1>
      </div>
    </section>
  );
};

export default KeyFactsBanner;
